import { pick } from 'lodash';

import { SIMILAR_PACKAGES_GET_PACKAGE_PARAMS } from '../constants/similar-packages';

const PACKAGE_FIELDS = [
  'availability',
  'extras',
  'price',
  'fuel_charge',
  'net_price',
  'transfer',
  'medical_insurance',
  'previous_price',
  'insurable',
  'misc_data',
  'instant_confirm',
  'labels',
  'cancellation_policy',
  'confirmability_index',
  'tour_id',
  'transfer_info',
  ...SIMILAR_PACKAGES_GET_PACKAGE_PARAMS,
];

/*
  Выбираем поля из массива выше, чтобы смержить их с 
  предыдущим стейтом
  Почему нельзя просто перезаписать? Загадка
  Возможно, тогда бы что-то ломалось......
*/
export const pickUpdatedPackageFields = (packageData) =>
  pick(packageData, PACKAGE_FIELDS);
